import { render, staticRenderFns } from "./preRegistration.vue?vue&type=template&id=54c2b5ea&"
import script from "./preRegistration.vue?vue&type=script&lang=js&"
export * from "./preRegistration.vue?vue&type=script&lang=js&"
import style0 from "./preRegistration.vue?vue&type=style&index=0&id=54c2b5ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports